let globalStore = null;

export const setGlobalStore = store => {
  globalStore = store;
};

export default () => globalStore;
